import React from "react";
import AndonDashboard from "../AndonDashBoard";
import WelcomeScreen from "../AndonDashBoard/welcomeScreen"
import { useSelector } from "react-redux";
import get from "lodash/get"
import { DASHBOARD_PERMISSION } from "../../constants";
import requireAuth from "../../hocs/requireAuth";

const DashboardScreen = () => {
  const permissions = useSelector(state => get(state, "auth.permissions"))
  const dashboardpermission = get(permissions, DASHBOARD_PERMISSION)
  return (
    <div>
      {dashboardpermission?(
        <AndonDashboard />
      ):<WelcomeScreen />}
    </div>
  );
};

export default requireAuth(DashboardScreen);